/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerExportToExcelQueryResponse, ApplicationsControllerExportToExcelPathParams } from "../../models/checklistsController/ApplicationsControllerExportToExcel";

function getApplicationsControllerExportToExcelUrl(id: ApplicationsControllerExportToExcelPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-applications/${id}/excel` as const }  
  return res
}

/**
 * @description Generates an Excel file containing the checklist application with all questions, answers, sources, and nested questions. Supports Unicode characters (including emojis) in filenames via RFC 5987 encoding.
 * @summary Export checklist application to Excel
 * {@link /api/v1/checklist-applications/:id/excel}
 */
export async function applicationsControllerExportToExcel(id: ApplicationsControllerExportToExcelPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerExportToExcelQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getApplicationsControllerExportToExcelUrl(id).url.toString(), ... requestConfig })  
  return res.data
}